import ChallengesDashboard from "@/pages/challenges/dashboard"
import Game from "@/pages/challenges/game"
import Review from "@/pages/challenges/review"
import { Navigate, Outlet, type RouteObject } from "react-router-dom"

const routes: RouteObject = {
  path: "challenges",
  element: <Outlet />,
  children: [
    {
      index: true,
      element: <ChallengesDashboard />,
    },
    {
      path: "review",
      element: <Review />,
    },
    {
      path: ":levelId",
      element: <Game />,
    },
    {
      path: "*",
      element: <Navigate to="challenges" replace />,
    },
  ],
}

export default routes
